var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue } from '../../../../Fct/generics/FctParams';
import { FaArrowDown } from 'react-icons/fa';
import cometList from '../../../../Fct/plugins/compoundv3/helpers/cometList.json';
import depositAssets from '../helpers/depositAssets.json';
export var WithdrawTo = createPlugin({
    protocol: 'COMPOUND_V3',
    type: 'ACTION',
    method: 'withdrawTo',
    description: 'Withdraw collateral that is not currently supporting an open borrow.',
    supportedContracts: cometList,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                methodParams: {
                    to: new FctAddress({ isPreview: true, icon: FaArrowDown }),
                    asset: new FctAddress({
                        destination: 'erc20',
                        options: depositAssets
                            .filter(function (token) { return token.chainId === Number(chainId); })
                            .map(function (asset) { return (__assign(__assign({}, asset), { value: asset.address })); }),
                        isPreview: true,
                        icon: FaArrowDown
                    }),
                    amount: new FctValue({ destination: 'wei_amount', isPreview: true }),
                },
            },
            output: {},
        });
    },
    assetFlow: function (params, chainId, _walletAddress, vaultAddress) {
        var to = params.to, _a = params.methodParams, asset = _a.asset, amount = _a.amount, destination = _a.to;
        if (!amount.value || !asset.value || !to.value || !destination.value || !vaultAddress)
            return [];
        if (typeof amount.value !== 'string' ||
            typeof asset.value !== 'string' ||
            typeof to.value !== 'string' ||
            typeof destination.value !== 'string')
            return [];
        var flow = [
            {
                address: destination.value,
                toSpend: [],
                toReceive: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
            },
            {
                address: to.value,
                toSpend: [
                    {
                        token: asset.value,
                        amount: amount.value,
                    },
                ],
                toReceive: [],
            },
        ];
        return flow;
    },
});
